const palettes = ["orange", "green", "blue", "indigo", "pink"];

export default palettes;
